/*
 * � 2020 Microsoft. All rights reserved.
 */

define('mainmenu',['pixi',
		'absolute',
		'util/RegularButton',
		'util/CustomWordWrapper',
		'absolute/stringmanager',
		'absolute/storagemanager',
		'absolute/screenmetrics',
		'Solitaire/DailyChallenges/KlondikeChallenge',
		'Solitaire/SolitaireGameMode',
		'Solitaire/Solitaire',
		'MenuUI/MenuTile',
		'MenuUI/ClassicGameTile',
		'gameconfig',
		'MenuUI/Menu',
		'lodash',
		'MenuUI/MultiPageMenu',
		'MenuUI/ThemeTile',
		'Solitaire/SolitaireStatistics',
		'MenuUI/StatsItemModel',
		'MenuUI/DetailStatsItemModel',
		'MenuUI/StatsOverviewTile',
		'Solitaire/MvvmStructure/Service/SolitaireDailyChallengeService',
        'Solitaire/MvvmStructure/Service/SolitaireStarClubService',
        'Solitaire/MvvmStructure/Service/BakedInSolvablesService',
		'MenuUI/DailyChallengeMainMenuTile',
		'MenuUI/StarCountDisplay',
		'Managers/StatManager',
		'MenuUI/DealWarningModal',
		'Solitaire/MvvmStructure/Service/ManifestService',
		'MenuUI/ControlFocusManager',
		'MenuUI/SideBar',
		'Managers/TelemetryManager',
		'Arkadium/GameEngine/Scenes/Nodes/SpriteNode',
		'Managers/ScaleManager',
		'util/NineSliceWrapper',
		'MenuUI/StarClubMainMenuTile',
		'MenuUI/ThemesMenu',
	'Managers/ScrollManager'
	],
	function (PIXI, Absolute, RegularButton, CustomWordWrapper, _s, StorageManager, ScreenMetrics, KlondikeChallenge, SolitaireGameMode,
	          SolitaireGame, MenuTile, ClassicGameTile, GameConfig, Menu, _, MultiPageMenu, ThemeTile,
	          SolitaireStatistics, StatsItemModel, DetailStatsItemModel, StatsOverviewTile,
              SolitaireDailyChallengeService, SolitaireStarClubService, BakedInSolvablesService, DailyChallengeMainMenuTile, StarCountDisplay,
	          StatManager, DealWarningModal, ManifestService, ControlFocusManager, SideBar, TelemetryManager, SpriteNode,
	          ScaleManager, NineSliceWrapper, StarClubMainMenuTile, ThemesMenu, ScrollManager) {
		var MainMenu = function (ui, game, mode) {
			this.initMainMenu(ui, game, mode);
		};

		MainMenu.prototype = Object.create(Absolute.Screen.prototype);
		if (!MainMenu.prototype.firstRun) {
			MainMenu.prototype.firstRun = true;
		}

		MainMenu.prototype.initMainMenu = function (ui, game, mode) {

			Absolute.Screen.call(this);

			this.ui = ui;
			this.ui.mainScreen = this;
			this.game = game;
			this._inited = false;
			this.mode = mode;
			this.sectionSelected = false;
			this.layoutType = 'xl';

			this.paginatedMenu = null;
			this.controlFocusManager = new ControlFocusManager();

			this.clickHandler = this.handleGameInput.bind(this);

			window.addEventListener('click', this.clickHandler);

		};

		MainMenu.prototype.handleResize = function () {
			if (!this.isShown) return;
			if (!this.scrollable) return;
			this.scrollTo(this.scrollable.y);
			this.handleMenuResize();
			this.scrollableFakeHeight = this.scrollable.height + Absolute.Coords.x(100);
			if (this.tutorialContainer) {
				this.updateTutorialContainer();
				if (this.tutorialContainer) this.updateTutorialPositioning();
				this.addChild(this.touchContainer);
				this.addChild(this.sidebar);
			}
			this.handleSidebarResize();
		};

		MainMenu.prototype.handleSidebarResize = function () {
			if ((this.scrollable.y < 0) && ((this.scrollableFakeHeight + this.scrollable.y) < Absolute.Coords.y(1080))) {
				this.scrollable.y = Absolute.Coords.y(1080) - this.scrollableFakeHeight;
				if (this.tutorialContainer) this.updateTutorialPositioning();
			}
			this.updateSidebar();
		};

		MainMenu.prototype.handleMenuResize = function () {
			this.container.y = (this.game.menuBar.menuButton.y + this.game.menuBar.menuButton.height)
				* (this.container.width
					* (this.container.children[0].pageGenerator.cardScale + 0.2) / ScaleManager.width)
				* (ScaleManager.height / Absolute.Coords.y(985));
			this.updatePagesPositions();
			this.scrollable.height = (this.currentWidth / this.container.width) * (Absolute.Coords.y(985) / ScaleManager.height)
				* (ScaleManager.width / Absolute.Coords.x(1840)) * this.currentHeight;
			this.scrollable.width = this.currentWidth;
			this.background.scale.set(
				1 / Math.min(ScaleManager.scaleFactorX, 1), 1 / Math.min(1, ScaleManager.scaleFactorY)
			);
			this.menuShadows.forEach(function (shadow) {
				shadow.scale.set(ScaleManager.scaleFactorX, 1);
			});
		};

		MainMenu.prototype.initTouchInterface = function () {
			// Dragging and panning
			this.lastDeltaY = 0;
			this.startY = 0;
			var hitArea = new PIXI.Rectangle(0, 0, Absolute.Coords.x(1920), Absolute.Coords.y(1080));
			this.touchContainer = new PIXI.DisplayObjectContainer();
			this.touchContainer.interactive = true;
			this.touchContainer.hitArea = hitArea;
			this.touchContainer.addChild(this.scrollable);
			this.touchContainer.mousedown = this.touchContainer.touchstart = this.handleDragStart.bind(this);
			this.touchContainer.mousemove = this.touchContainer.touchmove = this.handleDrag.bind(this);
			this.touchContainer.mouseupoutside = this.touchContainer.mouseup = this.touchContainer.touchend = this.touchContainer.touchendoutside = this.handleDragEnd.bind(this);
			this.addChild(this.touchContainer);
		};

		MainMenu.prototype.getLayoutType = function () {
			var layoutType, layoutConfig = ScaleManager.scaleParams['MenuConfigs']['MainMenuConfigs'].layoutConfigs;
			for (var i = 0; i < layoutConfig.length; i++) {
				if ((layoutConfig[i].screenWidth && ScaleManager.width < layoutConfig[i].screenWidth) ||
					(layoutConfig[i].screenHeight && ScaleManager.height < layoutConfig[i].screenHeight)) {
					layoutType = layoutConfig[i].type;
				}
			}
			return layoutType;
		};

        MainMenu.prototype.handleDragStart = function (data) {
            if (!this.parent)
                return;
            this.dragging = true;
            this.lastDeltaY = 0;
            this.startY = data.getLocalPosition(this.parent).y;
            this.enableButtons(false);
        };

		MainMenu.prototype.handleDrag = function (data) {

			if (!this.dragging) {
				return;
			}

			var pos = data.getLocalPosition(this.parent),
				delta = pos.y - this.startY;

			this.scrollTo(this.scrollable.y + (delta - this.lastDeltaY));

			this.lastDeltaY = delta;
		};

		MainMenu.prototype.handleDragEnd = function (data) {

			if (!this.dragging) {
				return;
			}
			this.dragging = false;
		};

		MainMenu.prototype.enableButtons = function (enable) {

			var i, l;

			for (i = 0, l = this.scrollable.children.length; i < l; i++) {
				this.scrollable.children[i].interactive = enable;
			}

		};

		MainMenu.prototype.init = function () {
			// todo fix to use background layer
			var background = PIXI.Sprite.fromFrame('win10_MS_bg.png');
			this.background = background;
			this.addChild(background);
			this.initShadows();
			this.controlFocusManager.addControl(this.game.menuBar.controlGroup[0], true, 'MenuButton');
			if (this.game.menuBar.newsDialog.newsAvailable()) {
				this.controlFocusManager.addControl(this.game.menuBar.newsButton, true, 'RightButtons');
			}
			if (this.game.menuBar.fullScreenEnabled) {
				this.controlFocusManager.addControl(this.game.menuBar.controlGroup[3], true, 'RightButtons');
			}
			this.buildStatsModels();
			this.buildMenu();

			this.initTouchInterface();
			ScaleManager.addElement(this, {scaleChangeSource: 'Full'});
			this.handleResize();
		};

		MainMenu.prototype.initShadows = function () {
			this.menuShadows = [];
			var cornerShadowWidth = Absolute.Coords.x(960),
				cornerShadowHeight = Absolute.Coords.y(1080);
			var leftShadow = this.buildShadow(
				0, 0, cornerShadowWidth, cornerShadowHeight, 0
			);
			var rightShadow = this.buildShadow(
				Absolute.Coords.x(1920), Absolute.Coords.y(1080), cornerShadowWidth, cornerShadowHeight, Math.PI
			);

			this.addChild(leftShadow);
			this.addChild(rightShadow);
			this.menuShadows.push(leftShadow, rightShadow);
		};

		MainMenu.prototype.buildShadow = function (x, y, width, height, rotation) {
			var shadow = new NineSliceWrapper(
				'mainmenu/shadow_stretch.png',
				width, height,
				10, 2, 5, 5);
			shadow.position.set(x, y);
			shadow.alpha = 0.5;
			shadow.rotation = rotation;
			return shadow;
		};

		MainMenu.prototype.onShow = function (isPortrait) {
			if (this.game.config.singleGame.enabled) {
				console.info('EMERGENCY!!! TRIED TO SHOW MAIN MENU')
				return;
			}
			this.isShown = true;

			if (this.scrollable) this.scrollable.y = 0;
			if (this.tutorialContainer) this.tutorialContainer.y = 0;

            this.ui.blockClicks();
			this.ui.showLoadingScreen();

			SolitaireDailyChallengeService.UpdateGlobalChallengeStats();

			Absolute.Screen.prototype.onShow.call(this);

			if (!this._inited) {
				this.init();
				this._inited = true;
			}

            this.ui.hideLoadingScreen();
            this.ui.unBlockClicks();

			if (this.gameMenu) {
				this.gameMenu.onShow();
			}
			if (this.challengeMenu) {
				this.challengeMenu.onShow();
			}
			if (this.statsMenu) {
				this.statsMenu.onShow();
			}
			// if (this.moreMenu) {
			// 	this.moreMenu.onShow();
			// }
			if (this.themeMenu) {
				this.themeMenu.onShow();
			}

			if (this.touchContainer) this.addChild(this.touchContainer);
			this.addChild(this.game.menuBar);
			this.game.menuBar.onShow(true, false, false, Absolute.StringManager('titles.MicrosoftSolitaireCollection'));
			this.game.menuBar.y = 0;

			this.ui.refreshBackground = true;

			//if (SolitaireStarClubService.IsValid()) {
			var completed = StatManager.GetValue('SCGlobalTotalCollectionsCompleted'),
				total = StatManager.GetValue('SCGlobalTotalCollections'),
				starsEarned = StatManager.GetValue('SCGlobalStarsEarned');


			if (this.collectionsCompletedText) {
				this.collectionsCompletedText.setText(completed + (total > 0 ? '/' + total : '') + ' ' + Absolute.StringManager('tiles.collectionsComplete'));
				this.starCountDisplay.onShow(starsEarned, true);
			}

			if (!this.sidebar) {
				this.initSidebar();
			}
			this.scrollTo(0);

			// fix for ie bug with broken menu
			if (this.mode && SolitaireGameMode.hasOwnProperty(this.mode)) {
				if (this.mode === 'DailyChallenge') {
					this.handleChallengeClick();
				} else if (this.mode === 'StarClub') {
					this.handleStarClubClick();
				} else {
					// this.game.menuBar.toggleMainSlideOut(function () {
					this.alpha = 0.01;
					setTimeout(function () {
						this.alpha = 1;
						this.game.startGame(SolitaireGameMode[this.mode], null, false);
						this.mode = null;
					}.bind(this));
					// }.bind(this));
				}
			}

			// Menu load complete event
            if (this.firstRun) {
                TelemetryManager.mainMenuLoad();
				this.firstRun = false;
			}
			this.handleResize();


			setTimeout(function () {
				this.game.menuBar.handleResize();
			}.bind(this), 20);
            ScrollManager.add(this, this.doScroll, this);

            var installId = StorageManager.fetch('InstallId');
            if (!installId) {
                var guid = Absolute.Utils.makeGUID();
                StorageManager.store('InstallId', guid);
            }

            BakedInSolvablesService.Initialize(
                function () {                    
                }.bind(this)
            );
		};

		MainMenu.prototype.initSidebar = function () {
			this.sidebar = new SideBar({
				availableHeight: 200, partialHeight: 100,
				onScrollUpdate: function (p) {
				}.bind(this)
			});
			this.addChild(this.sidebar);
			this.sidebar.position.set(Absolute.Coords.x(1900), Absolute.Coords.y(67));
			this.updateSidebar();
		};

		MainMenu.prototype.onHide = function () {
			this.isShown = false;
			if (this.sidebar) {
				this.removeChild(this.sidebar);
				this.sidebar = null;
			}
			this.resetControlManager();
			Absolute.Screen.prototype.onHide.call(this);
			ScrollManager.remove(this);
		};

		MainMenu.prototype.handlePause = function () {

		};

		MainMenu.prototype.handleResume = function () {

		};

		MainMenu.prototype.handleOrientationChange = function (isPortrait) {

			Absolute.Screen.prototype.handleOrientationChange.call(this, isPortrait);

		};

		MainMenu.prototype.buildStatsModels = function () {
			this._statsModels = {};

			// klondike
			var klondike = this.makeStatsModel(SolitaireGameMode.Klondike);
			klondike.model.addStat("HighScore", SolitaireStatistics.Current.GetHighScoreFormatString, (klondike.key));

			// spider
			var spider = this.makeStatsModel(SolitaireGameMode.Spider);
			spider.model.addStat("Stacks", SolitaireStatistics.Current.GetStacksFormatString, (spider.key));
			spider.model.addStat("HighScore", SolitaireStatistics.Current.GetHighScoreFormatString, (spider.key));

			// freecell
			var freecell = this.makeStatsModel(SolitaireGameMode.FreeCell);
			freecell.model.addStat("BestTime", SolitaireStatistics.Current.GetBestTimeFormatString, (freecell.key));
			freecell.model.addStat("AverageTime", SolitaireStatistics.Current.GetAverageTimeFormatString, (freecell.key));

			// pyramid
			var pyramid = this.makeStatsModel(SolitaireGameMode.Pyramid);
			pyramid.model.addStat("Matches", SolitaireStatistics.Current.GetMatchesFormatString, (pyramid.key));
			pyramid.model.addStat("HighScore", SolitaireStatistics.Current.GetHighScoreFormatString, (pyramid.key));
			pyramid.model.addStat("RowsCleared", SolitaireStatistics.Current.GetRowsClearedFormatString, (pyramid.key));

			// tripeaks
			var tripeaks = this.makeStatsModel(SolitaireGameMode.TriPeaks);
			tripeaks.model.addStat("TotalPeaksCleared", SolitaireStatistics.Current.GetPeaksClearedFormatString, (tripeaks.key));
			tripeaks.model.addStat("BoardsCleared", SolitaireStatistics.Current.GetBoardsFormatString, (tripeaks.key));
			tripeaks.model.addStat("HighScore", SolitaireStatistics.Current.GetHighScoreFormatString, (tripeaks.key));

			var dailyChallenge = new StatsItemModel(SolitaireGameMode.DailyChallenge);
			dailyChallenge.addStat("ChallengesWon", SolitaireStatistics.Current.GetDCChallengesWonFormatString);
			dailyChallenge.addStat("ChallengesPlayed", SolitaireStatistics.Current.GetDCChallengesPlayedFormatString);
			dailyChallenge.addStat("DaysCompleted", SolitaireStatistics.Current.GetDCDaysCompletedFormatString);
			dailyChallenge.addStat("BronzeBadgesWon", SolitaireStatistics.Current.GetDCBronzeBadgesWonFormatString);
			dailyChallenge.addStat("SilverBadgesWon", SolitaireStatistics.Current.GetDCSilverBadgesWonFormatString);
			dailyChallenge.addStat("GoldBadgesWon", SolitaireStatistics.Current.GetDCGoldBadgesWonFormatString);
			dailyChallenge.addStat("DiamondBadgesWon", SolitaireStatistics.Current.GetDCDiamondBadgesWonFormatString);
			dailyChallenge.addStat("PerfectCompletions", SolitaireStatistics.Current.GetDCPerfectCompletionsFormatString);

			this._statsModels[SolitaireGameMode.getModeById(SolitaireGameMode.DailyChallenge)] = dailyChallenge;

			var starClub = new StatsItemModel(SolitaireGameMode.StarClub);
			starClub.addStat("TotalStarsEarned", SolitaireStatistics.Current.GetSCTotalStarsEarnedFormatString);
			starClub.addStat("ChallengesCompleted", SolitaireStatistics.Current.GetSCChallengesCompletedFormatString);
			starClub.addStat("PacksUnlocked", SolitaireStatistics.Current.GetSCPacksUnlockedFormatString);
			starClub.addStat("CollectionsUnlocked", SolitaireStatistics.Current.GetSCCollectionsUnlockedFormatString);
			starClub.addStat("CrownsEarned", SolitaireStatistics.Current.GetSCCrownsEarnedFormatString);
			starClub.addStat("CompletionPercent", SolitaireStatistics.Current.GetSCCompletionPercentageFormatString);
			this._statsModels[SolitaireGameMode.getModeById(SolitaireGameMode.StarClub)] = starClub;

		};

		MainMenu.prototype.makeStatsModel = function (gameMode) {
			var statKey = new SolitaireStatistics.StatKey(gameMode, "+TOTAL" + SolitaireGameMode.getModeById(gameMode).toUpperCase());
			var statsModel = new StatsItemModel(gameMode);
			statsModel.addStat("GamesPlayed", SolitaireStatistics.Current.GetGamesPlayedFormatString, (statKey));
			if (gameMode != SolitaireGameMode.TriPeaks && gameMode != SolitaireGameMode.Pyramid) {
				statsModel.addStat("GamesWon", SolitaireStatistics.Current.GetGamesWonFormatString, (statKey));
				statsModel.addStat("GamesLost", SolitaireStatistics.Current.GetGamesLostFormatString, (statKey));
				statsModel.addStat("WinPercentage", SolitaireStatistics.Current.GetPercentWon, (statKey));
			}
			this._statsModels[SolitaireGameMode.getModeById(gameMode)] = statsModel;

			return {key: statKey, model: statsModel};
		};


		MainMenu.prototype.buildMenu = function () {

			this.gameTiles = [];

			// Games
			_.each(GameConfig.UI.mainMenuGames, function (tileData) {
				tileData.isMainMenu = true;
				if (this.game.config.singleGame.enabled) tileData.mode = this.game.config.singleGame.mode;
				var cgTile = new ClassicGameTile(tileData, this, this.setTutorialAsSeen.bind(this));
				this.gameTiles.push(cgTile);
				this.controlFocusManager.addControl(cgTile, false, 'ClassicGames');
			}, this);
			var gameMenuData = {
				'tiles': this.gameTiles,
				'label': ''
			};
			this.gameMenu = new Menu(_.extend(gameMenuData, ScaleManager.scaleParams['MenuConfigs']['MainMenuConfigs']));

			// Daily Challenge
			var dailyChallengeTile,
				dailyChallengeTileData = GameConfig.UI.mainMenuChallenges.dailyChallenge,
				starClubTile,
				starClubTileData = GameConfig.UI.mainMenuChallenges.starClub,
				collectionsCompleteLetterStyle = {
					font: 'Bold ' + Absolute.ScreenMetrics.getResScale() * 30 + "px Arial",
					fontFamily: 'segoe',
					fill: '#ffffff',
					tint: 0xffffff,
					align: 'left'
				};

			dailyChallengeTileData.action = this.handleChallengeClick.bind(this);
			dailyChallengeTileData.labelPosition.x = Absolute.Coords.x(dailyChallengeTileData.labelPosition.x);
			dailyChallengeTileData.labelPosition.y = Absolute.Coords.x(dailyChallengeTileData.labelPosition.y - 5);
			dailyChallengeTile = new DailyChallengeMainMenuTile(dailyChallengeTileData, this.game);

			this.controlFocusManager.addControl(dailyChallengeTile, false, 'Challenges');

			// Star Club
			starClubTileData.action = this.handleStarClubClick.bind(this);
			starClubTileData.labelPosition.x = Absolute.Coords.x(starClubTileData.labelPosition.x);
			starClubTileData.labelPosition.y = Absolute.Coords.x(starClubTileData.labelPosition.y - 5);
			starClubTile = new StarClubMainMenuTile(starClubTileData, this.game);

			this.controlFocusManager.addControl(starClubTile, false, 'Challenges');

			var challengeMenuConfig = {
				'tiles': [dailyChallengeTile, starClubTile],
				'label': '',
				'tilePaddingY': Absolute.Coords.y(120)
			};

			this.challengeMenu = new Menu(_.extend(challengeMenuConfig, ScaleManager.scaleParams['MenuConfigs']['MainMenuConfigs']));
			this.challengeMenu.y = Absolute.Coords.y(414);

			// Themes
			this.themeTiles = [];
			var themeChange = function (themeId) {
				_.each(this.themeTiles, function (themeTile) {
					themeTile.updateState(themeId === themeTile.themeId)
				});
			}.bind(this);
			_.each(GameConfig.UI.mainMenuThemes, function (tileData) {
				tileData.disableOnClick = false;
				tileData.themeChangeCallback = themeChange;
				tileData.maxWidth = Absolute.Coords.x(240);
				var themeTile = new ThemeTile(tileData, this, this.game);
				this.themeTiles.push(themeTile);
				this.controlFocusManager.addControl(themeTile, false, 'Themes');
			}, this);
			this.themeMenu = new ThemesMenu(_.extend({
				'tiles': this.themeTiles,
				'label': 'themes',
				'labelPosition': {
					'y': -Absolute.Coords.y(1),
					'x': Absolute.Coords.x(1)
				}
			}, ScaleManager.scaleParams['MenuConfigs']['MainMenuConfigs']), this.game);

			// Stats
			var statsTiles = [];
			var statsTileConfig = {};

			_.each(this._statsModels, function (statsModel) {
				var statsTile = new StatsOverviewTile(statsTileConfig, statsModel, this);
				statsTiles.push(statsTile);
				if (!(statsModel.gameMode === SolitaireGameMode.DailyChallenge || statsModel.gameMode === SolitaireGameMode.StarClub)) {
					this.controlFocusManager.addControl(statsTile, false, 'Statistics');
				}
			}, this);
			this.statsMenu = new Menu(_.extend({
				'tiles': statsTiles,
				'label': ''
			}, ScaleManager.scaleParams['MenuConfigs']['MainMenuConfigs']));

			this.scrollable = new PIXI.DisplayObjectContainer();
			this.container = new PIXI.DisplayObjectContainer();
			this.container.addChild(this.gameMenu);
            this.container.addChild(this.challengeMenu);

            if (!Absolute.Platform.isMobile()) {
                this.container.addChild(this.themeMenu);
            }
			this.container.addChild(this.statsMenu);
			this.currentWidth = Absolute.Coords.x(1840);

			this.entirePile = new PIXI.Graphics();

			this.updatePagesPositions();
			this.addChild(this.scrollable);
			this.scrollable.addChild(this.container);

			this.scrollable.addChild(this.entirePile);
		};

		MainMenu.prototype.updatePagesPositions = function () {
			var prevChild, scale = (this.container.width / this.currentWidth),
				xPos = Absolute.Coords.x(98) * scale, yGap = Absolute.Coords.y(60) * scale,
				startY = Absolute.Coords.y(20) * scale;
			this.currentHeight = Absolute.Coords.y(140);
			this.container.children.forEach(function (c) {
				c.x = xPos;
				c.y = prevChild ? prevChild.y + prevChild.height + yGap : startY;
				this.currentHeight += c.height + (prevChild ? yGap : 0);
				prevChild = c;
			}.bind(this));
		};

		MainMenu.prototype.handleChallengeClick = function () {
			if (SolitaireDailyChallengeService.IsValid()) {
				this.setTutorialAsSeen();
				this.game.navDaily();
			} else {
				this.showManifestWarning();
			}
		};

		MainMenu.prototype.handleAwardsClick = function () {
			this.game.navAwardsAchievements();
		};

		MainMenu.prototype.handleStarClubClick = function () {
			if (SolitaireStarClubService.IsValid()) {
				this.setTutorialAsSeen();
				this.game.navStarClub();
			} else {
				this.showManifestWarning();
			}
		};

		MainMenu.prototype.handleStatsTileClick = function (gameMode) {
			if (gameMode !== SolitaireGameMode.DailyChallenge && gameMode !== SolitaireGameMode.StarClub) {
				var statsDetailModel = new DetailStatsItemModel(gameMode);
				this.game.navStatsDetail(statsDetailModel);
			}
		};

		MainMenu.prototype.showManifestWarning = function () {
			this.ui.showWarning(_s("dialogs.manifestWarningHeadline"), _s("dialogs.manifestWarningContent"),
				function () {
					this.ui.hideLoadingScreen();
					this.game.navBack();
				}.bind(this)
			);
		};

		MainMenu.prototype.setTutorialAsSeen = function () {
			if (!this.tutorialContainer) return;
			this.touchContainer.removeChild(this.tutorialContainer);
			this.addChild(this.touchContainer);
			this.addChild(this.sidebar);
			this.addChild(this.game.menuBar);

			this.game.menuBar.y = 0;
			this.tutorialContainer = null;
			StorageManager.store('TutorialSeen', true);
			this.handleResize();
		};

		MainMenu.prototype.initTutorial = function () {
			var seen = StorageManager.fetch('TutorialSeen');
			if (seen) return;
			TelemetryManager.newInstall();
			this.tutorialContainer = new PIXI.DisplayObjectContainer();
			this.touchContainer.addChild(this.tutorialContainer);
			this.modalTutorial = new PIXI.Graphics();
			this.tutorialContainer.addChild(this.modalTutorial);
			this.tutorialArrows = [];
			_.times(5, function () {
				var arrow = PIXI.Sprite.fromFrame('fue/arrow.png');
				arrow.anchor.set(.5, .5);
				this.tutorialArrows.push(arrow);
				this.tutorialContainer.addChild(arrow);
			}.bind(this));
			this.tutorialPopup = PIXI.Sprite.fromFrame('fue/shortPopup.png');
			var closeBtn = new RegularButton('fue/closeBtn/down.png', 'fue/closeBtn/over.png', 'fue/closeBtn/up.png');
			closeBtn.x = (this.tutorialPopup.width / 2) - Absolute.Coords.y(40);
			closeBtn.y = Absolute.Coords.y(35);
			closeBtn.anchor.set(.5, .5);
			closeBtn.interactive = true;
			closeBtn.buttonMode = true;
			closeBtn.onClick.add(function () {
				this.setTutorialAsSeen();
			}.bind(this));
			this.tutorialPopup.anchor.set(.5, 0);
			var textItself = Absolute.StringManager('fue.first');
			textItself = textItself.replace('\n\n\n', '{yyy}');
			textItself = textItself.replace('\n', ' ');
			textItself = textItself.replace('{yyy}', '\n\n');
			var titleLetterStyle = {
				font: "bold " + Absolute.ScreenMetrics.getResScale() * 25 + "px Arial",
				fontFamily: 'segoe', fill: '#ffffff', align: 'center', wordWrap: true, wordWrapWidth: Absolute.Coords.x(700)
			}, fueText = new PIXI.Text(textItself, titleLetterStyle);
			CustomWordWrapper.doTextCustomWrap(
				fueText, Absolute.ScreenMetrics.getResScale() * 25, 'bold', Absolute.Coords.x(700), Absolute.Coords.y(260)
			);
			fueText.anchor.set(.5, 0);
			fueText.x = 0;
			fueText.y = Absolute.Coords.y(65);
			this.tutorialPopup.addChild(fueText);
			this.tutorialPopup.addChild(closeBtn);
			this.tutorialContainer.addChild(this.tutorialPopup);
			this.updateTutorialContainer();
			this.handleResize();
		};

		MainMenu.prototype.updateTutorialContainer = function () {
			var realX = (this.container.x + this.gameMenu.x) * this.scrollable.scale.x,
				realY = (this.container.y + this.gameMenu.y) * this.scrollable.scale.y,
				realWidth = this.gameMenu.width * this.scrollable.scale.x,
				realHeight = this.gameMenu.height * this.scrollable.scale.y,
				offsetX = Absolute.Coords.x(35) * this.scrollable.scale.x,
				offsetY = Absolute.Coords.y(20) * this.scrollable.scale.y;
			realX -= offsetX;
			realY -= offsetY;
			realWidth += offsetX;
			realHeight += offsetY * 1.2;
			this.modalTutorial.clear();
			this.modalTutorial.beginFill(0x000000, .9);
			this.modalTutorial.drawRect(realX, -44444, realWidth, 44444 + realY);
			this.modalTutorial.drawRect(0, -44444, realX, 88888);
			this.modalTutorial.drawRect(realX + realWidth, -44444, 44444, 88888);
			this.modalTutorial.drawRect(realX, realY + realHeight, realWidth, 44444);
			this.modalTutorial.endFill();
			this.modalTutorial.interactive = true;
			this.modalTutorial.mousedown = this.modalTutorial.touchstart = function () {
			};
			this.modalTutorial.mousemove = this.modalTutorial.touchmove = function () {
			};
			this.modalTutorial.mouseupoutside = this.modalTutorial.mouseup = this.modalTutorial.touchend = this.modalTutorial.touchendoutside = function () {
			};
			var scaleX = (Absolute.Coords.x(1920) / ScaleManager.width),
				scaleY = (Absolute.Coords.y(1080) / ScaleManager.height);
			var arrowWidth = Absolute.Coords.x(99) * scaleX, arrowHeight = Absolute.Coords.y(95) * scaleY;
			var intendedScale = ScaleManager.width / Absolute.Coords.x(1920);
			if (intendedScale > 1) intendedScale = 1;
			arrowWidth *= intendedScale;
			arrowHeight *= intendedScale;
			_.each(this.tutorialArrows, function (e, i) {
				e.width = arrowWidth;
				e.height = arrowHeight;
				e.x = Absolute.Coords.x(180) + realX + ((realWidth / 5) * i);
				e.y = realY;
			});
			var isLayoutXL = (this.getLayoutType() === 'xl');
			this.tutorialPopup.position.set(realX + (realWidth / 2), realY + realHeight + Absolute.Coords.y(20));
			var popupWidth = Absolute.Coords.x(837) * scaleX, popupHeight = Absolute.Coords.y(254) * scaleY;
			popupWidth *= intendedScale * (isLayoutXL ? 1.3 : 1.7);
			popupHeight *= intendedScale * (isLayoutXL ? 1.3 : 1.7);
			this.tutorialPopup.width = popupWidth;
			this.tutorialPopup.height = popupHeight;
			_.each(this.tutorialArrows, function (e) {
				e.visible = isLayoutXL;
			});
		};

		MainMenu.prototype.doScroll = function (e) {
			if (!this.scrollable) return;
			var deltaY = 0;
			if (!e) e = window.event;
			if (e.wheelDelta) {
				deltaY = e.wheelDelta / 35;
			} else if (e.detail) {
				deltaY = -e.detail / 3;
			}
			this.scrollTo(this.scrollable.y + (deltaY * 100));
		};

		MainMenu.prototype.scrollTo = function (y) {
			if (!this.scrollable) return;
			if (this.scrollableFakeHeight <= Absolute.Coords.y(1080)) {
				this.scrollable.y = 0;
				return;
			}
			this.scrollable.y = y;
			if (this.scrollable.y > 0) this.scrollable.y = 0;
			var posY = this.scrollableFakeHeight - Absolute.Coords.y(1080);
			if (Math.abs(this.scrollable.y) > posY) {
				this.scrollable.y = -posY;
			}
			if (this.tutorialContainer) this.updateTutorialPositioning();
			if (this.sidebar) this.sidebar.updateHandleByPercent(100 * Math.abs(this.scrollable.y) / Math.abs(posY));
		};

		MainMenu.prototype.handleCommand = function (command, isMouseWheel) {
			if (isMouseWheel) return;
			if (this.game.menuBar.gameOptionsPopup) {
				this.game.menuBar.gameOptionsPopup.handleCommand(command);
				return;
			}
			// isMouseWheel = !!isMouseWheel;
			// this.scrollable.y = Math.max(this.scrollable.y - 1, -this.scrollable.height);
			this.selectSection(command, isMouseWheel);
			switch (command) {
				case 'Right': {
					if (!this.sectionSelected) return;
					this.controlFocusManager.focusNextControl(1);
					break;
				}
				case 'Left':
					if (!this.sectionSelected) return;
					this.controlFocusManager.focusNextControl(-1);
					break;
				case 'Up': {
					if (this.controlFocusManager.getCurrentControl()) {
						if (this.controlFocusManager.focusNextControl(-1)) {
							this.startScrolling(-2);
						}
					} else {
						this.startScrolling(-2);
					}
					break;
				}
				case 'Down': {
					if (this.controlFocusManager.getCurrentControl()) {
						if (this.controlFocusManager.focusNextControl(1)) {
							this.startScrolling(2);
						}
					} else {
						this.startScrolling(2);
					}
					break;
				}
				case 'Activate':
					this.controlFocusManager.activateCurrentControl();
					break;
				case 'Unfocus':
					this.controlFocusManager.unfocusCurrentControl();
					break;
			}
		};

		MainMenu.prototype.handlePageChange = function (from, to) {
			switch (to) {
				case 0:
					this.controlFocusManager.setFocusGroup('MenuButton', true);
					break;
				case 1:
					this.controlFocusManager.setFocusGroup('RightButtons', true);
					break;
				case 2:
					this.controlFocusManager.setFocusGroup('ClassicGames', true);
					break;
				case 3:
					this.controlFocusManager.setFocusGroup('Challenges', true);
					break;
				case 4:
					this.controlFocusManager.setFocusGroup('Themes', true);
					break;
				case 5:
					this.controlFocusManager.setFocusGroup('Statistics', true);
					break;
			}
		};

		MainMenu.prototype.handleVisibilityChange = function (hidden) {
			if (!hidden) {
				this.ui.resize();
			}
		};


		MainMenu.prototype.selectSection = function (command, isMouseWheel) {
			if (command === 'Tab' || command === 'ShiftTab') {
				this.controlFocusManager.focusCurrentControl();
				this.sectionSelected = true;
				if (command === 'Tab') {
					if (this.page === 5) {
						this.handlePageChange(this.page, 0);
						this.page = 0;
					} else {
						this.controlFocusManager.nextFocusGroup();
					}
				} else if (command === 'ShiftTab') {
					if (this.page === 0) {
						this.handlePageChange(this.page, 5);
						this.page = 5;
					} else {
						this.controlFocusManager.prevFocusGroup();
					}
				}
				switch (this.controlFocusManager.currentFocusGroup) {
					case 'MenuButton':
						this.page = 0;
						break;
					case 'RightButtons':
						this.page = 1;
						break;
					case 'ClassicGames':
						this.page = 2;
						break;
					case 'Challenges':
						this.page = 3;
						break;
					case 'Themes':
						this.page = 4;
						break;
					case 'Statistics':
						this.page = 5;
						break;
				}
				var current = this.controlFocusManager.getCurrentControl();
				if (!isMouseWheel) this.scrollTo(-current._bounds.y + current.height * 2);
			}
		};

		MainMenu.prototype.startScrolling = function (delta) {
			this.sidebar.updateByArrow(delta);
		};

		MainMenu.prototype.updateSidebar = function () {
            if (!this.sidebar) return;

            var height = this.game.menuBar.menuBarHeight;
            var resizeScale = 1;

            if (Absolute.Platform.isMobile()) {
                height *= 0.7;
                if (Absolute.ScreenMetrics.isPortrait()) {
                    resizeScale = 0.5;
                }
            }

			var screenScaleX = ScaleManager.width / Absolute.Coords.x(1920),
                screenScaleY = ScaleManager.height / Absolute.Coords.y(1080);

            this.sidebar.scale.set(1, 1);

            this.sidebar.width = this.sidebar.width / screenScaleX * resizeScale;
            
            this.sidebar.height = this.sidebar.height / screenScaleY;

			this.sidebar.y = (this.tutorialContainer) ? 0 : height / screenScaleY;
			this.sidebar.x = Absolute.Coords.x(1900) - (this.sidebar.width - (this.sidebar.width * screenScaleX));
			var availableHeight, partialHeight, posY;
			availableHeight = this.scrollableFakeHeight;
			partialHeight = Absolute.Coords.y(1080);
			posY = availableHeight - Absolute.Coords.y(1080);
			this.sidebar.resetDimensions(availableHeight, partialHeight, function (p) {
				var y = -Math.abs(posY) * p / 100;
				this.scrollable.y = y;
				if (this.scrollable.y > 0) this.scrollable.y = 0;
				if (Math.abs(this.scrollable.y) > posY) {
					this.scrollable.y = -posY;
				}
				if (this.tutorialContainer) this.updateTutorialPositioning();
			}.bind(this), (this.tutorialContainer ? (ScaleManager.height) : (ScaleManager.height - height)));
			this.sidebar.visible = (availableHeight >= Absolute.Coords.y(1080));
			this.sidebar.updateHandleByPercent(100 * Math.abs(this.scrollable.y) / Math.abs(posY));
		};

		MainMenu.prototype.updateTutorialPositioning = function () {
			this.tutorialContainer.y = this.scrollable.y;
			if (this.game.menuBar) this.game.menuBar.y = this.scrollable.y;
		};

		MainMenu.prototype.handleGameInput = function () {
			this.resetControlManager();
		};

		MainMenu.prototype.resetControlManager = function () {
			this.controlFocusManager.unfocusCurrentControl();
			this.sectionSelected = false;
		};

		return MainMenu;
	});


